import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import { SectionCard } from '../molecules/SectionCard';
import { CustomText } from '../atoms';
import { SectionIcons } from '../../stateManagement/SettingsContext';
import { SectionData } from '../../interfaces';
import { CategoriesIcon } from '../atoms/CategoriesIcon';

interface SectionGridProps {
  sections?: SectionData[] | null;
  sectionIcons?: SectionIcons[];
  textColor?: string;
  sectionBgColor?: string;
  sectionIconsTranslations?: SectionIcons[];
  sectionsHeading: string;
  sectionHelperText: string;
  sectionCardTextColor: string;
  primaryAccentColor?: string;
  secondaryAccentColor?: string;
  categoriesHeadingTextColor?: string;
  onClickMore: (title: string) => void;
  gradientAccentColor?: string;
  moreClickHref?: (title: string) => string;
}

export const SectionGrid: React.FC<SectionGridProps> = ({
  sections,
  sectionIcons,
  textColor,
  sectionBgColor = '#ffffff',
  sectionIconsTranslations,
  sectionsHeading,
  sectionHelperText,
  sectionCardTextColor,
  primaryAccentColor,
  secondaryAccentColor,
  categoriesHeadingTextColor,
  onClickMore,
  gradientAccentColor,
  moreClickHref,
  // onClickFaq,
}) => {
  const translatedSectionIcons = sectionIcons?.map(item => {
    const sectionIconsTranslation = sectionIconsTranslations?.find(t => t.id === item.id);
    return {
      ...item, // Keep all properties from `items`
      name: sectionIconsTranslation?.name ?? item.name, // Override `title` if translation exists
    };
  });
  return (
    <>
      <CustomText
        variant="h1"
        fontSize={{ base: 'xl', sm: '2xl', md: '3xl' }}
        fontWeight="bold"
        color={textColor}
      >
        <Box display="inline-flex" alignItems="center" gap="2">
          <CategoriesIcon color={primaryAccentColor} />
          {sectionsHeading}
        </Box>
      </CustomText>

      <Box height="3px" width="60px" background={gradientAccentColor} />
      <Box height="1px" width="100%" background={gradientAccentColor} mb="6" />
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing="6" mt="4vh">
        {sections?.map(section => {
          // Find the corresponding icon from sectionIcons
          // const sortedFaqs = [...(section.faq_data || [])].sort(
          //   (a, b) => b.faq_updated_at - a.faq_updated_at,
          // );
          const matchingIcon = translatedSectionIcons?.find(icon => icon.id === section.section_id);
          const resolvedIcon =
            matchingIcon?.property === 'icon' ? matchingIcon.icon : matchingIcon?.svg;
          const resolvedProperty = matchingIcon?.property;
          const formattedSectionTitle = `${section.section_name.toLowerCase().replace(/\s+/g, '-')}`;

          return (
            <SectionCard
              key={section.section_id}
              section_id={section.section_id}
              textColor={sectionCardTextColor}
              bgColor={sectionBgColor}
              sectionName={section.section_name}
              faqs={section.faq_data}
              // faqs={sortedFaqs}
              icon={resolvedIcon || ''}
              iconType={resolvedProperty}
              onClickMore={() => onClickMore(formattedSectionTitle)}
              sectionHelperText={sectionHelperText}
              helperTextColor={textColor}
              primaryAccentColor={primaryAccentColor}
              secondaryAccentColor={secondaryAccentColor}
              categoriesHeadingTextColor={categoriesHeadingTextColor}
              moreClickHref={moreClickHref ? moreClickHref(formattedSectionTitle) : undefined}
            />
          );
        })}
      </SimpleGrid>
    </>
  );
};
